import { render } from "./OEMset.vue?vue&type=template&id=5ecfcc14"
import script from "./OEMset.vue?vue&type=script&lang=js"
export * from "./OEMset.vue?vue&type=script&lang=js"

import "./OEMset.vue?vue&type=style&index=0&id=5ecfcc14&lang=css"
script.render = render

export default script